module.exports = __webpack_public_path__ + "static/img/17.1eb48b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/zh/17.png
// module id = rmCc
// module chunks = 0